import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

export default function ScrollToTop() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    const firstRender = isFirstRender.current;
    isFirstRender.current = false;
    if (location.pathname === "/login") return;
    if (location.pathname === "/add-venue" && (window.location.hash || (location.state as any)?.scrollToForm)) return;
    if (location.pathname === "/sign-up" && (location.state as any)?.openSignup) return;

    if (location.pathname === "/pricing") {
      const targetId = location.hash === "#faq" ? "faq" : "packages";
      const target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }

    // A fresh page load already starts at the top; scrolling here would force a
    // synchronous layout of the whole just-mounted page (a long task on load).
    if (firstRender) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.state, location.hash]);

  return null;
}
